<ng-container *ngIf="siteService?.siteSetting?.contactUs">
    <div class="site-footer__widget footer-contacts d-md-block d-none">
        <h5 class="footer-contacts__title text-uppercase">{{"contact_us"|translate}}</h5>
        <ul class="footer-contacts__contacts">
            <li *ngIf="siteService?.siteSetting?.contactUs.phone">
                <div class="flex flex-row">
                    <mat-icon svgIcon="call-footer"></mat-icon>
                    <span style="direction: ltr;">{{siteService?.siteSetting?.contactUs.phone}}</span>
                </div>
            </li>
            <li *ngIf="siteService?.siteSetting?.contactUs.timing">
                <div class="flex flex-row">
                    <mat-icon svgIcon="clock-footer"></mat-icon>
                <span> {{siteService?.siteSetting?.contactUs.timing}}</span>
                </div>
            </li>
            <li *ngIf="siteService?.siteSetting?.contactUs.email">
                <div class="flex flex-row">
                    <mat-icon svgIcon="email-footer"></mat-icon>
                <span> {{siteService?.siteSetting?.contactUs.email}}</span>
                </div>
            </li>
            <li *ngIf="siteService?.siteSetting?.contactUs.address">
                <div class="flex flex-row location-icon">
                    <mat-icon svgIcon="location-footer"></mat-icon>
                <span> {{siteService?.siteSetting?.contactUs.address}} </span>
                </div>
            </li>
        </ul>
    </div>

    <div class="site-footer__widget footer-contacts mt-0 d-md-none d-block">
        <h5 class="footer-contacts__title text-uppercase py-2 m-0" (click)="showList = !showList">
            {{"contact_us"|translate}}</h5>
        <ul class="footer-contacts__contacts p-2 m-0 collapse" [ngClass]="{'show': showList}">
            <li *ngIf="siteService?.siteSetting?.contactUs.phone"><i class="footer-contacts__icon fas fa-mobile-alt"></i>
                <span style="direction: ltr;">{{siteService?.siteSetting?.contactUs.phone}}</span>
            </li>
            <li *ngIf="siteService?.siteSetting?.contactUs.timing"><i class="footer-contacts__icon far fa-clock"></i>
                {{siteService?.siteSetting?.contactUs.timing}}</li>
            <li *ngIf="siteService?.siteSetting?.contactUs.email"><i
                    class="footer-contacts__icon far fa-envelope"></i>{{siteService?.siteSetting?.contactUs.email}}</li>
            <li *ngIf="siteService?.siteSetting?.contactUs.address"><i
                    class="footer-contacts__icon fas fa-globe-americas"></i>
                {{siteService?.siteSetting?.contactUs.address}}
            </li>
        </ul>
    </div>
</ng-container>

<!-- #DEP to be deprecated -->
<ng-container *ngIf="!siteService?.siteSetting?.contactUs">
    <div class="site-footer__widget footer-contacts d-md-block d-none">
        <h5 class="footer-contacts__title text-uppercase">{{"contact_us"|translate}}</h5>

        <!-- <div class="footer-contacts__text">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer in feugiat lorem. Pellentque ac placerat tellus.
        </div> -->
<!--
        <ul class="footer-contacts__contacts">
            <li><mat-icon svgIcon="call-footer" class="footer-contacts__icon"></mat-icon><span style="direction: ltr;">13380333</span>
            </li>
            <li><mat-icon svgIcon="clock-footer" class="footer-contacts__icon"></mat-icon> Sun-Thu 8:00 - 17:00</li>
            <li><mat-icon svgIcon="email-footer" class="footer-contacts__icon"></mat-icon> info@qetaat.com</li>
            <li><mat-icon svgIcon="email-footer" class="footer-contacts__icon"></mat-icon> order@qetaat.com</li>
            <li><mat-icon svgIcon="location-footer" class="footer-contacts__icon"></mat-icon> <a
                    href=" https://goo.gl/maps/vJAf5EhGDL7LYuFo8"> Office 42, Building 657 (Jeera III), Road 2811, 428
                    Seef District, Kingdom of Bahrain</a></li>
        </ul> -->
    </div>

    <div class="site-footer__widget footer-contacts mt-0 d-md-none d-block">
        <h5 class="footer-contacts__title text-uppercase py-2 m-0" (click)="showList = !showList">
            {{"contact_us"|translate}}</h5>
        <ul class="footer-contacts__contacts p-2 m-0 collapse" [ngClass]="{'show': showList}">
            <li><i class="footer-contacts__icon fas fa-mobile-alt"></i> <span style="direction: ltr;">13380333</span>
            </li>
            <li><i class="footer-contacts__icon far fa-clock"></i> Sun-Thu 8:00 - 17:00</li>
            <li><i class="footer-contacts__icon far fa-envelope"></i> info&#64;qetaat.com</li>
            <li><i class="footer-contacts__icon far fa-envelope"></i> order&#64;qetaat.com</li>
            <li><i class="footer-contacts__icon fas fa-globe-americas"></i> <a
                    href=" https://goo.gl/maps/vJAf5EhGDL7LYuFo8"> Office 42, Building 657 (Jeera III), Road 2811, 428
                    Seef District, Kingdom of Bahrain</a></li>
        </ul>
    </div>
</ng-container>
